import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import { ArrowBack, FilterFramesOutlined } from '@mui/icons-material';
import { ServiceContext } from 'providers/ServiceProvider';
import { Origination } from 'constants/contexts';

const HeaderLinks = ({ onClickClose, id, canTestVerification, onVerificationTest }) => {
  const { t } = useTranslation();
  const [activeService] = useContext(ServiceContext);
  
  return (
    <>
      <IconButton fontSize='medium' color='transparent' tooltip={t('Tooltips.VerificationTypes.BackToList')} onClick={onClickClose}>
        <ArrowBack />
      </IconButton>
      {id && activeService?.route === Origination.serviceRoute && (
        <>
          <IconButton
            fontSize='medium'
            color='transparent'
            onClick={() => onVerificationTest(id)}
            disabled={!canTestVerification}
            tooltip={
              canTestVerification
                ? t('Tooltips.Test')
                : t('VerificationTypes.TestingApplicabilityFormula.Validations.InvalidApplicabilityFormula')
            }
          >
            <FilterFramesOutlined />
          </IconButton>
        </>
      )}
    </>
  );
};

HeaderLinks.propTypes = {
  onClickClose: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  onVerificationTest: PropTypes.func.isRequired,
  canTestVerification: PropTypes.bool.isRequired
};
export default HeaderLinks;
